import { ExternalUser } from 'api/integrations';
import { User } from 'api/models';
import { activeUsersAndTeamsFromIndexedB } from 'queries/members';
import { logger } from 'services';

// useExternalIntegrationUserDetails will be used to get a user object if:
// the external integration action (ex: slack message) author is part of the system, we'll show the full user object
// else the external integratio action (slack message) author is not part of the system, we'll show the username from the integration
// else the integration user (the slack bot in this case)
export const useExternalIntegrationUserDetails = (
  externalUser: ExternalUser | undefined,
  user: User,
): User => {
  const { users } = activeUsersAndTeamsFromIndexedB.getActiveUsersAndTeams;

  //   if the user is not part of the system
  if (user && externalUser && !externalUser.rlUserId) {
    return {
      ...user,
      firstName: externalUser.key || user?.firstName,
      lastName: '',
    };
  }

  if (externalUser?.rlUserId) {
    const rocketlaneUser = users?.find?.(
      (usr) => usr.userId === externalUser.rlUserId,
    );

    if (rocketlaneUser) {
      return rocketlaneUser;
    }

    if (rocketlaneUser == null) {
      logger.info(
        `rocketlane user is not available for rlUserId - ${externalUser.rlUserId}`,
      );

      return {
        ...user,
        firstName: externalUser.key || user?.firstName,
        lastName: '',
      };
    }
  }

  return user || {};
};
